"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "aao": 8240,
    "abh": 8241,
    "abv": 8242,
    "acm": 8243,
    "acq": 8244,
    "acw": 8245,
    "acx": 8246,
    "acy": 8247,
    "adf": 8248,
    "ads": 8249,
    "aeb": 8250,
    "aec": 8251,
    "aed": 8252,
    "aen": 8253,
    "afb": 8254,
    "afg": 8255,
    "ajp": 8256,
    "ajs": 8257,
    "apc": 8258,
    "apd": 8259,
    "arb": 8260,
    "arq": 8261,
    "ars": 8262,
    "ary": 8263,
    "arz": 8264,
    "ase": 8265,
    "asf": 8266,
    "asp": 8267,
    "asq": 8268,
    "asw": 8269,
    "auz": 8270,
    "avl": 8271,
    "ayh": 8272,
    "ayl": 8273,
    "ayn": 8274,
    "ayp": 8275,
    "bbz": 8276,
    "bfi": 8277,
    "bfk": 8278,
    "bjn": 8279,
    "bog": 8280,
    "bqn": 8281,
    "bqy": 8282,
    "btj": 8283,
    "bve": 8284,
    "bvl": 8285,
    "bvu": 8286,
    "bzs": 8287,
    "cdo": 8288,
    "cds": 8289,
    "cjy": 8290,
    "cmn": 8291,
    "cnp": 8292,
    "coa": 8293,
    "cpx": 8294,
    "csc": 8295,
    "csd": 8296,
    "cse": 8297,
    "csf": 8298,
    "csg": 8299,
    "csl": 8300,
    "csn": 8301,
    "csp": 8302,
    "csq": 8303,
    "csr": 8304,
    "csx": 8305,
    "czh": 8306,
    "czo": 8307,
    "doq": 8308,
    "dse": 8309,
    "dsl": 8310,
    "dsz": 8311,
    "dup": 8312,
    "ecs": 8313,
    "ehs": 8314,
    "esl": 8315,
    "esn": 8316,
    "eso": 8317,
    "eth": 8318,
    "fcs": 8319,
    "fse": 8320,
    "fsl": 8321,
    "fss": 8322,
    "gan": 8323,
    "gds": 8324,
    "gom": 8325,
    "gse": 8326,
    "gsg": 8327,
    "gsm": 8328,
    "gss": 8329,
    "gus": 8330,
    "hab": 8331,
    "haf": 8332,
    "hak": 8333,
    "hds": 8334,
    "hji": 8335,
    "hks": 8336,
    "hos": 8337,
    "hps": 8338,
    "hsh": 8339,
    "hsl": 8340,
    "hsn": 8341,
    "icl": 8342,
    "iks": 8343,
    "ils": 8344,
    "inl": 8345,
    "ins": 8346,
    "ise": 8347,
    "isg": 8348,
    "isr": 8349,
    "jak": 8350,
    "jax": 8351,
    "jcs": 8352,
    "jhs": 8353,
    "jks": 8354,
    "jls": 8355,
    "jos": 8356,
    "jsl": 8357,
    "jus": 8358,
    "kgi": 8359,
    "knn": 8360,
    "kvb": 8361,
    "kvk": 8362,
    "kvr": 8363,
    "kxd": 8364,
    "lbs": 8365,
    "lce": 8366,
    "lcf": 8367,
    "liw": 8368,
    "lls": 8369,
    "lsb": 8370,
    "lsc": 8371,
    "lsg": 8372,
    "lsl": 8373,
    "lsn": 8374,
    "lso": 8375,
    "lsp": 8376,
    "lst": 8377,
    "lsv": 8378,
    "lsw": 8379,
    "lsy": 8380,
    "ltg": 8381,
    "lvs": 8382,
    "lws": 8383,
    "lzh": 8384,
    "max": 8385,
    "mdl": 8386,
    "meo": 8387,
    "mfa": 8388,
    "mfb": 8389,
    "mfs": 8390,
    "min": 8391,
    "mnp": 8392,
    "mqg": 8393,
    "mre": 8394,
    "msd": 8395,
    "msi": 8396,
    "msr": 8397,
    "mui": 8398,
    "mzc": 8399,
    "mzg": 8400,
    "mzy": 8401,
    "nan": 8402,
    "nbs": 8403,
    "ncs": 8404,
    "nsi": 8405,
    "nsl": 8406,
    "nsp": 8407,
    "nsr": 8408,
    "nzs": 8409,
    "okl": 8410,
    "orn": 8411,
    "ors": 8412,
    "pel": 8413,
    "pga": 8414,
    "pgz": 8415,
    "pks": 8416,
    "prl": 8417,
    "prz": 8418,
    "psc": 8419,
    "psd": 8420,
    "pse": 8421,
    "psg": 8422,
    "psl": 8423,
    "pso": 8424,
    "psp": 8425,
    "psr": 8426,
    "pys": 8427,
    "rib": 8428,
    "rms": 8429,
    "rnb": 8430,
    "rsi": 8431,
    "rsl": 8432,
    "rsm": 8433,
    "rsn": 8434,
    "sdl": 8435,
    "sfb": 8436,
    "sfs": 8437,
    "sgg": 8438,
    "sgx": 8439,
    "shu": 8440,
    "slf": 8441,
    "sls": 8442,
    "sqk": 8443,
    "sqs": 8444,
    "sqx": 8445,
    "ssh": 8446,
    "ssp": 8447,
    "ssr": 8448,
    "svk": 8449,
    "swc": 8450,
    "swh": 8451,
    "swl": 8452,
    "syy": 8453,
    "szs": 8454,
    "tmw": 8455,
    "tse": 8456,
    "tsm": 8457,
    "tsq": 8458,
    "tss": 8459,
    "tsy": 8460,
    "tza": 8461,
    "ugn": 8462,
    "ugy": 8463,
    "ukl": 8464,
    "uks": 8465,
    "urk": 8466,
    "uzn": 8467,
    "uzs": 8468,
    "vgt": 8469,
    "vkk": 8470,
    "vkt": 8471,
    "vsi": 8472,
    "vsl": 8473,
    "vsv": 8474,
    "wbs": 8475,
    "wuu": 8476,
    "xki": 8477,
    "xml": 8478,
    "xmm": 8479,
    "xms": 8480,
    "yds": 8481,
    "ygs": 8482,
    "yhs": 8483,
    "ysl": 8484,
    "ysm": 8485,
    "yue": 8486,
    "zib": 8487,
    "zlm": 8488,
    "zmi": 8489,
    "zsl": 8490,
    "zsm": 8491
};
//# sourceMappingURL=extlang.json.js.map